import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Edit, Trash2, CalendarClock, BookOpen } from "lucide-react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"

function ServiceCard({ service, onEdit, onDelete }) {
  const navigate = useNavigate()
  const descriptionEntries = Object.entries(service.description || {})
  const firstDescription = descriptionEntries[0]

  return (
    <Card
      className="group hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-gray-700 cursor-pointer overflow-hidden"
      onClick={() => navigate(`/services/${service.id}`)}
    >
      <CardContent className="p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-0 sm:justify-between">
          <div className="flex items-start space-x-4 flex-1">
            <div className="relative flex-shrink-0">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-purple-500 to-purple-600 text-white flex items-center justify-center shadow-lg transform transition-transform group-hover:scale-105">
                <BookOpen className="h-6 w-6" />
              </div>
            </div>
            <div className="space-y-2 flex-1 min-w-0 pr-2 sm:pr-4">
              <h3 className="text-base sm:text-lg font-semibold tracking-tight text-gray-900 dark:text-gray-100 group-hover:text-purple-600 line-clamp-2">
                {service.title}
              </h3>
              {firstDescription && (
                <div className="space-y-1">
                  <h4 className="text-sm font-medium text-purple-600 dark:text-purple-400 line-clamp-1">
                    {firstDescription[0]}
                  </h4>
                  <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 line-clamp-2">
                    {firstDescription[1]}
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="flex space-x-2 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity flex-shrink-0">
            <Button
              variant="outline"
              size="icon"
              className="h-8 w-8 border-gray-200 hover:border-purple-500 hover:text-purple-500"
              onClick={(e) => {
                e.stopPropagation()
                onEdit(service)
              }}
            >
              <Edit className="h-4 w-4" />
            </Button>
            <Button
              variant="outline"
              size="icon"
              className="h-8 w-8 border-gray-200 hover:border-red-500 hover:text-red-500"
              onClick={(e) => {
                e.stopPropagation()
                onDelete(service)
              }}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-100 dark:border-gray-800">
          <div className="flex items-center text-xs text-gray-500 dark:text-gray-400">
            <CalendarClock className="h-3 w-3 mr-2" />
            <span className="truncate">
              Last modified:{" "}
              {new Date(service.modified_at).toLocaleDateString()}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

ServiceCard.propTypes = {
  service: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.object,
    modified_at: PropTypes.string.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default ServiceCard
